import { el } from "@dhx/ts-common/dom";
import { getCount } from "./helpers";

export function imageButton(item: any, widgetName: string) {
	const getAriaAttrs = item => {
		const attrs = {
			"aria-disabled": item.disabled ? "true" : "false",
		};

		if (item.twoState || item.active) {
			attrs["aria-pressed"] = item.active ? "true" : "false";
		}

		if (!item.value && item.src && item.tooltip) {
			attrs["aria-label"] = `${item.tooltip} ${item.count || ""}`;
		}

		return attrs;
	};
	const baseClass = "dhx_" + widgetName + "-button-image";
	const isRibbon = widgetName === "ribbon";
	return el(
		"button.dhx_button",
		{
			class:
				baseClass +
				(item.size ? " " + baseClass + "--" + item.size : "") +
				(!item.value && item.src ? " " + baseClass + "--icon" : "") +
				(isRibbon && item.$openIcon ? " " + baseClass + "--select" : "") +
				(item.active ? " " + baseClass + "--active" : ""),
			"data-dhx-id": item.id,
			type: "button",
			...getAriaAttrs(item),
		},
		[
			isRibbon &&
				item.value &&
				item.$openIcon &&
				el("span.dxi.dxi-menu-right", {
					class: baseClass + "__caret",
					"aria-hidden": "true",
				}),
			item.html
				? el("div", {
						class: baseClass + "__text",
						".innerHTML": item.html,
				  })
				: item.value &&
				  el(
						"span",
						{
							class: baseClass + "__text",
						},
						item.value
				  ),
			item.src &&
				el("span", {
					class: baseClass + "__image",
					style: { backgroundImage: `url(${item.src})` },
					role: "presentation",
				}),
			item.count > 0 && getCount(item, baseClass + "__count", true),
		]
	);
}
